import { render, staticRenderFns } from "./btnSwitch.vue?vue&type=template&id=8fe254b0&scoped=true&"
import script from "./btnSwitch.vue?vue&type=script&lang=js&"
export * from "./btnSwitch.vue?vue&type=script&lang=js&"
import style0 from "./btnSwitch.vue?vue&type=style&index=0&id=8fe254b0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe254b0",
  null
  
)

export default component.exports